import * as React from "react";
import { cn } from "../../lib/utils";

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Row = React.forwardRef<HTMLDivElement, RowProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex flex-row gap-4 items-center", className)}
      {...props}
    />
  )
);

Row.displayName = "Row";